import React, { useState, useEffect } from 'react';
import './Community.css';
import PageBanner from '../components/PageBanner/PageBanner';
import { apiCall } from '../utils/api';

const Community = () => {
  const [chats, setChats] = useState([]);
  const [inputText, setInputText] = useState('');
  const [isSending, setIsSending] = useState(false);

  // Avatar colors for variety
  const avatarColors = ['#ff6b35', '#2ec4b6', '#e71d36', '#ff9f1c', '#011627', '#6a0572'];

  const fetchChats = async () => {
    try {
      const data = await apiCall('/community-chat');
      setChats(data);
    } catch (error) {
      console.error('Error fetching chats:', error);
    }
  };

  useEffect(() => {
    fetchChats();
  }, []);

  const handleSendChat = async (e) => {
    e.preventDefault();
    if (!inputText.trim() || isSending) return;

    setIsSending(true);
    try {
      const newChat = {
        senderName: "User",
        role: "user",
        message: inputText,
      };

      await apiCall('/community-chat', 'POST', newChat);
      setInputText('');
      await fetchChats();
    } catch (error) {
      console.error('Error sending chat:', error);
    } finally {
      setIsSending(false);
    }
  };

  const getAvatarStyle = (name) => {
    const charCode = name.charCodeAt(0);
    const color = avatarColors[charCode % avatarColors.length];
    return { backgroundColor: color };
  };

  return (
    <div className="community-page">
      <div className="community-header-fixed">
        <PageBanner
          title="Community Hub"
          subtitle="Real-time discussions with our global yoga family"
          pageKey="community"
        />
      </div>

      {/* Marquee Display */}
      <div className="chat-slide-wrapper">
        <div className="chat-marquee">
          {chats.filter(c => c.role === 'admin').length > 0 ? (
            <>
              {chats.filter(c => c.role === 'admin').map((chat) => (
                <div key={chat._id} className="chat-card">
                  <span className={`chat-badge badge-${chat.role || 'user'}`}>
                    Official
                  </span>
                  <div className="chat-avatar" style={getAvatarStyle(chat.senderName)}>
                    {chat.senderName.charAt(0)}
                  </div>
                  <h3 className="chat-sender">{chat.senderName}</h3>
                  <div className="chat-card-body">
                    <p>{chat.message}</p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="chat-card empty-card">
              <p>No official updates yet. Stay tuned!</p>
            </div>
          )}
        </div>
      </div>

      <div className="community-container">
        {/* Discussion List (History) */}
        <div className="community-messages-list">
          <h3 className="list-title">Recent Activity</h3>
          <div className="messages-grid">
            {chats.length > 0 ? (
              chats.map((msg) => (
                <div key={`list-${msg._id}`} className="message-item">
                  <div className="message-header">
                    <span className="user-avatar-small" style={getAvatarStyle(msg.senderName)}>
                      {msg.senderName.charAt(0)}
                    </span>
                    <span className="user-name">{msg.senderName}</span>
                    <span className="message-time">
                      {new Date(msg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                  <p className="message-text">{msg.message}</p>
                </div>
              ))
            ) : (
              <div className="empty-history">
                <p>No discussions yet. Start one now!</p>
              </div>
            )}
          </div>
        </div>

        {/* Input area */}
        <div className="chat-input-section">
          <h2>Chat with us</h2>
          <form className="chat-form" onSubmit={handleSendChat}>
            <input 
              type="text" 
              className="chat-input" 
              placeholder="What's on your mind?..." 
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              maxLength={200}
              disabled={isSending}
            />
            <button type="submit" className="send-btn" disabled={isSending}>
              {isSending ? 'Sending...' : 'Post Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Community;
